import { openBlock as t, createElementBlock as e, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ a('<path fill="#D80027" d="M40 20c0-2.446-.44-4.79-1.244-6.956L20 12.174l-18.756.87A19.957 19.957 0 0 0 0 20c0 2.447.44 4.79 1.244 6.956l18.756.87 18.756-.87A19.955 19.955 0 0 0 40 20Z"></path><path fill="#6DA544" d="M20 40c8.6 0 15.93-5.427 18.756-13.043H1.244C4.07 34.572 11.401 40 20 40Z"></path><path fill="#338AF3" d="M1.244 13.043h37.512C35.93 5.429 28.599 0 20 0 11.4 0 4.07 5.427 1.244 13.043Z"></path><path fill="#F0F0F0" d="M20.435 25.652a5.652 5.652 0 1 1 2.688-10.625 6.956 6.956 0 1 0 0 9.945c-.8.434-1.715.68-2.688.68Z"></path><path fill="#F0F0F0" d="m24.783 16.087.748 2.105 2.018-.959-.959 2.018 2.106.749-2.106.749.96 2.018-2.019-.96-.748 2.106-.749-2.105-2.018.959.96-2.018L20.87 20l2.105-.749-.96-2.018 2.019.96.749-2.106Z"></path>', 5), c = [
  o
];
function h(n, i) {
  return t(), e("svg", l, [...c]);
}
const r = { render: h };
export {
  r as default,
  h as render
};
